<template>
  <div class="dashboard">
    <MessageAlert ref="messageAlert" />
    <header class="dashboard-header">
      <div class="nav-buttons">
        <!-- Home button -->
        <button @click="$router.push('/devices')" class="menu-button-style"><i class="fas fa-home"></i> {{ $t('DashboardLayout.home_label') }}</button>
        <!-- Admin button -->
        <button v-if="isAdmin" @click="$router.push('/admin')" class="menu-button-style">{{ $t('DashboardLayout.admin_label') }}</button>
      </div>

      <div class="user-info">
        <!-- Language selector -->
        <div class="dropdown">
          <button class="dropbtn">
            <span :class="['fi', `fi-${selectedLanguage.flagCode}`]"></span>
          </button>
          <div class="dropdown-content">
            <a v-for="flag in flags" :key="flag.name" @click="setLanguage(flag)">
              <span :class="['fi', `fi-${flag.flagCode}`]"></span>
            </a>
          </div>
        </div>

        <!-- User info -->
        <span class="user-name">{{ userData.firstName || 'User' }}</span>
        <button @click="logout" class="menu-button-style">{{ $t('MainPage.logout_text') }}</button>
      </div>
    </header>

    <main class="dashboard-content">
      <router-view />
    </main>
  </div>
</template>

<script>
import MessageAlert from '@/components/MessageAlert.vue';
import axios from 'axios';
import { backendUrl, frontendUrl } from '@/config/envVariablesConfig';
import { flags, getLanguage, setLanguage } from '@/language';
import keycloak from '@/keycloak';


export default {
  components: {
    MessageAlert
  },
  data() {
    return {
      userData: {
          userID: '',
          firstName: '',
          familyName: '',
          email: '',
          language: ''
      },
      flags: Object.values(flags),
      selectedLanguage: getLanguage(),
    };
  },
  methods: {
    logout() {
      keycloak.logout({
        redirectUri: frontendUrl,
      });
    },
    setLanguage(newLang) {
      this.selectedLanguage = setLanguage(newLang.language_code);
      this.$i18n.locale = this.selectedLanguage.language_code;
    },
    showError(message) {
    this.$nextTick(() => {
        if (this.$refs.messageAlert) {
          console.log('MessageAlert found', this.$refs.messageAlert);
          this.$refs.messageAlert.error.show_message = true;
          this.$refs.messageAlert.error.message = message;

          setTimeout(() => {
            if (this.$refs.messageAlert) {
              console.log('Hiding error message');
              this.$refs.messageAlert.error.show_message = false;
            }
          }, 3000);
        } else {
          console.error('MessageAlert component is not initialized yet.');
        }
      });
    },
    showSuccess(message) {
      this.$nextTick(() => { // Ensure the DOM is updated before accessing $refs
        if (this.$refs.messageAlert) {
          console.log('MessageAlert found', this.$refs.messageAlert);
          this.$refs.messageAlert.success.show_message = true;
          this.$refs.messageAlert.success.message = message;

          // Hide the success after 3 seconds
          setTimeout(() => {
            if (this.$refs.messageAlert) {
              this.$refs.messageAlert.success.show_message = false;
            }
          }, 3000);
        } else {
          console.error('MessageAlert component is not initialized yet.');
        }
      });
    },
    async checkOrAddProfile() {
        try {
            await keycloak.updateToken?.(30).catch(() => {});

            const resp = await axios.post(
            `${backendUrl}/api/common/profile`,
            {},
            {
              headers: {
                Authorization: `Bearer ${keycloak.token}`,
                'Content-Type': 'application/json',
                Accept: 'application/json'
              }
            });

            // check is request returned any error
            if (!(resp.status === 200 || resp.status === 201)) {
              this.showError(resp.data.error);
              return;
            }

            // validate payload shape
            const payload = resp.data;
            if (!payload?.success || !payload?.data) {
              this.showError(this.$t('MainPage.response_invalid_structure'));
              return;
            }

            this.userData = payload.data; // { userID, firstName, familyName, email, username, language }
            this.showSuccess(`${this.$t('MainPage.hello_text')} ${this.userData.firstName}`);
        }
        catch (error) {
            console.error(`fetchDeviceAndOwnerData: ${error}`);
            this.showError(this.$t('MainPage.response_internal_error'));
            return;
        }
    },
  },
  async mounted() {
    await this.checkOrAddProfile();
  },
  computed: {
    isAdmin() {
      const roles = keycloak.tokenParsed?.realm_access?.roles || [];
      return roles.includes('administrator');
    }
  }
};
</script>


<style scoped>
/* Header styling */
.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #6494ec;
  border-bottom: 1px solid #ddd;
}

.user-info {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.nav-buttons {
  display: flex;
  align-items: center;
}

.user-name {
  font-weight: bold;
  color: #2c3e50;
  margin-right: 15px;
}

.menu-button-style {
  padding: 8px 15px;
  background-color: #2ecc71;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
}

.menu-button-style:hover {
  background-color: #27ae60;
}

/* Language Dropdown */
.dropdown {
  position: relative;
  display: inline-block;
  margin-right: 15px;
}

.dropbtn {
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 24px;
  display: flex;
  align-items: center;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 40px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content a {
  padding: 10px;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #333;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown-content a:hover {
  background-color: #ddd;
}

.dropbtn .fi {
  margin-right: 10px;
}

.dropdown-content .fi {
  font-size: 18px;
}

</style>
